import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import _isEmpty from 'lodash/isEmpty';
import { manualSchedulesInstancesPropTypes, manualSchedulesSummaryPreviewPropTypes } from 'constants/propTypes';
import { bem } from 'helpers/class-name';
import Message from 'components/Message';
import SchedulesGroupForDate from './SchedulesGroupForDate';
import SchedulesListLoader from './SchedulesListLoader';
import SchedulesEmpty from '../SchedulesEmpty/SchedulesEmpty';
import messages from '../../Schedules.messages';
import './SchedulesList.scss';

const { block, element } = bem('schedules-list');

export default class SchedulesList extends Component {
  static propTypes = {
    isDesktop: PropTypes.bool,
    schedulesInstances: manualSchedulesInstancesPropTypes,
    ...manualSchedulesSummaryPreviewPropTypes,
  };

  constructor(props) {
    super(props);
    this.scrollParentRef = React.createRef();
    this.listItemRefsById = {};
  }

  componentDidMount = () => {
    const { selectedScheduleId } = this.props;

    if (selectedScheduleId) {
      this.scrollToSelectedItem();
    }
  };

  componentDidUpdate = prevProps => {
    const { selectedScheduleId } = this.props;
    const { selectedScheduleId: prevSelectedScheduleId } = prevProps;

    if (selectedScheduleId !== prevSelectedScheduleId) {
      this.scrollToSelectedItem();
    }
  };

  registerRef = (id, node) => {
    this.listItemRefsById = {
      ...this.listItemRefsById,
      [id]: node,
    };
  };

  scrollToSelectedItem = () => {
    const { selectedScheduleId } = this.props;
    const node = this.listItemRefsById[selectedScheduleId];

    if (node && window.requestAnimationFrame) {
      // For some reason the on-mount scrolling doesn't fire reliably unless we wait a tick.
      window.requestAnimationFrame(() => {
        node.scrollIntoView({
          block: 'nearest',
          inline: 'nearest',
        });
      });
    }
  };

  renderContent = () => {
    const {
      fetchSchedulesInstances,
      schedulesInstances,
      isLoading,
      filterQueries,
      venueId,
      nextDate,
      isDesktop,
      startDate,
    } = this.props;

    if (isLoading && !nextDate) {
      return <SchedulesListLoader />;
    }

    if (_isEmpty(schedulesInstances)) {
      return <SchedulesEmpty isWithoutFilters={_isEmpty(filterQueries)} venueId={venueId} startDate={startDate} />;
    }

    return (
      <div className={element('groups')} ref={this.scrollParentRef}>
        <InfiniteScroll
          loadMore={!isLoading && !!nextDate ? fetchSchedulesInstances : () => {}}
          hasMore={!!nextDate}
          loader={<SchedulesListLoader forNextItems key="loader" />}
          getScrollParent={() => this.scrollParentRef.current}
          useWindow={!isDesktop}
          initialLoad={false}>
          {Object.entries(schedulesInstances).map(([date, schedules]) => (
            <SchedulesGroupForDate key={date} date={date} schedules={schedules} registerRef={this.registerRef} />
          ))}
        </InfiniteScroll>
      </div>
    );
  };

  render() {
    return (
      <div className={block()} data-cypress="schedules-list">
        <div className={element('header', 'grid grid--flush')} data-cypress="schedules-list-header">
          <div className="grid__item 1/9">
            <Message as="div" className={element('header-item')} message={messages.board.list.headerTime} />
          </div>
          <div className="grid__item 2/9">
            <Message as="div" className={element('header-item')} message={messages.board.list.headerClass} />
          </div>
          <div className="grid__item 2/9">
            <Message as="div" className={element('header-item')} message={messages.board.list.headerInstructor} />
          </div>
          <div className="grid__item 2/9">
            <Message as="div" className={element('header-item')} message={messages.board.list.headerSchedule} />
          </div>
          <div className="grid__item 2/9" />
        </div>
        {this.renderContent()}
      </div>
    );
  }
}
